import "./VideoCard.css";

const VideoCard = ({ name, description, videoUrl, textFooter, footerColor = "#222" }) => {
  return (
    <div className="videoCard">
      <div className="videoCard__inner">

        {/* Frente */}
        <div className="videoCard__front">
          <div className="videoCard__header">
            <h2 className="videoCard__title">{name}</h2>
          </div>

          {/* Descripción debajo del título */}
          {description && (
            <div className="videoCard__description">
              <p>{description}</p>
            </div>
          )}

          {/* Video embebido */}
          <div className="videoCard__body">
            <div className="videoCard__video">
              <iframe
                src={videoUrl}
                title={name}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>

          {/* Footer con texto */}
          <div className="videoCard__footer" style={{ backgroundColor: footerColor }}>
            <p>{textFooter}</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default VideoCard;
